export enum SelftestColors {
	PRIMARY = 'var(--color-selftest-primary)',
	PRIMARY900 = 'var(--color-selftest-primary-900)',
	PRIMARY800 = 'var(--color-selftest-primary-800)',
	PRIMARY700 = 'var(--color-selftest-primary-700)',
	PRIMARY600 = 'var(--color-selftest-primary-600)',
	PRIMARY500 = 'var(--color-selftest-primary-500)',
	PRIMARY400 = 'var(--color-selftest-primary-400)',
	PRIMARY300 = 'var(--color-selftest-primary-300)',
	PRIMARY200 = 'var(--color-selftest-primary-200)',
	PRIMARY100 = 'var(--color-selftest-primary-100)',
}
